import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib/store';
import * as actions from './get-order-result.actions';
import { GetOrderResultState } from './get-order-result.state';

/**
 * getOrderResult initial state
 */
export const getOrderResultInitialState: GetOrderResultState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for GetOrderResult Store
 */
export const getOrderResultReducerFeatures: ReducerTypes<GetOrderResultState, ActionCreator[]>[] = [
  on(actions.setGetOrderResult, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateGetOrderResult, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetGetOrderResult, () => getOrderResultInitialState),

  on(actions.cancelGetOrderResultRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failGetOrderResult, (state, payload) => asyncStoreItemAdapter.failRequest(state, payload.requestId)),

  on(actions.setGetOrderResultFromApi, actions.updateGetOrderResultFromApi, (state, payload) =>
    asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * GetOrderResult Store reducer
 */
export const getOrderResultReducer = createReducer(getOrderResultInitialState, ...getOrderResultReducerFeatures);
